import { 
	createSlice, 
	PayloadAction, 
	createAction 
} from "@reduxjs/toolkit";

export type AppVersionState = {
	value: string | null;
};

const initialState: AppVersionState = {
	value: null,
};

const clearAction = createAction("clear");

const appVersionSlice = createSlice({
	name: "appVersion",
	initialState,
	reducers: {
		setAppVersion(state, action: PayloadAction<string>) {
			state.value = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(clearAction, () => initialState);
	},
});

export const { setAppVersion } = appVersionSlice.actions;
export default appVersionSlice.reducer;
